import { IIconProps } from '../../typescript/interfaces/common.interface';

export default function CircleIcon({ stroke, ...others }: IIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width='40'
      height='40'
      x='0'
      y='0'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
      {...others}>
      <g>
        <clipPath id='a'>
          <path d='M0 0h24v24H0z' fill={stroke ?? '#000000'} opacity='1' data-original={stroke ?? '#000000'}></path>
        </clipPath>
        <g clip-path='url(#a)'>
          <path
            fill={stroke ?? '#000000'}
            d='M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z'
            opacity='1'
            data-original={stroke ?? '#000000'}></path>
        </g>
      </g>
    </svg>
  );
}
